<template>
  <div class="data-management-contents">
    <div>
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>
      <!-- Study dropdown groups -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            :todayDate="todaysDate"
            @onApplyCountry="getDataFromRadioButton"
            @onApplySites="getDataFromCheckbox"
            @onApplyParticipants="getParticipantsDataFromCheckbox"
            @onFetchedParticipants="fetchedParticipants"
            @onApplyFpi="filter"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :siteListInParticipants="siteListInParticipants"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <div :class="isDataLoaded === false ? 'greyout-dashboard' : ''">
      <!-- Compliance Insights Card -->
      <b-row v-if="complianceWidgets" :class="`pb-10 ${zoomGraphValue === 'compliance-insights-card' ? '' : 'full-width'}`" v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-insights-card'">
        <b-colxx class="pl-0 pb-6 pr-0" xl="12" lg="12" md="12" :class="zoomGraphValue === 'compliance-insights-card' ? 'compliance-insights-card-zoom' : ''" style="transition-duration: 0.2s">
          <ComplianceInsightsCard
            titleChart="Top 10 Non-Compliant Activities"
            :siteListInParticipants="siteListInParticipants"
            :collectionMetricsRaw="overallCollectionMetricRaw"
            :participantRaw="overallCollectionMetricParticipantRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :customType="'scrollbar2d'"
            :zoomGraphValue="zoomGraphValue"
            :listParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.overallCollectionMetricRaw"
            v-on:zoomEnabled="zoomGraphValue = 'compliance-insights-card'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :complianceInsightScoreRaw="complianceInsightScoreRaw"
            :complianceInsightScore="complianceInsightScore"
            :complianceInsightNonCompliantActivitiesRaw="complianceInsightNonCompliantActivitiesRaw"
            :complianceInsightNonCompliantActivities="complianceInsightNonCompliantActivities"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
      </b-row>
      <!-- End of Compliance Insights Card -->
      <b-row class="pb-10" v-if="complianceWidgets">
        <b-colxx :class="zoomGraphValue === 'study-participant-status-maps' ? 'col-xl-12 study-participant-status-maps-zoom' : 'col-xl-12'" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-participant-status-maps'" lg="12" md="12" class="pl-0 pb-10">
          <complianceStatusMaps
            titleChart="Geodemographic Compliance"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'study-participant-status-maps'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            containerId="blank"
            :rawData="this.getDouprawParticipantStatus"
            :rawDataCSV="this.getDouprawParticipantStatus"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.rawParticipantStatus"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :checkingstatusofdata="checkingstatusofdata"
            :participantsSelected="participantsSelected"
            style="background: linear-gradient(180deg, #657792 0%, #264065 100%); !important;"
            :conversioninvalid="conversioninvalid"
          />
        </b-colxx>
      </b-row>

      <!-- Compliance Change Score   -->
      <b-row class="pb-10">
        <b-colxx :class="zoomGraphValue === 'compliance-rate-over-time' ? 'col-xl-12 compliance-rate-over-time-zoom' : 'col-xl-12'" v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-rate-over-time'" lg="12" md="12" class="pl-0 pb-10">
          <ComplianceRateOverTime
            titleChart="Compliance Rate Over Time"
            downloadId="compliance-rate-over-time"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'compliance-rate-over-time'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :rawData="complianceRateOverTimeRawData"
            :dataLoaded="dataLoaded.complianceRateOverTimeRawData"
          >
          </ComplianceRateOverTime>
        </b-colxx>
      </b-row>
      <!-- End Compliance Change Score   -->

      <!-- Overall Data Collection with Completion Metrics   -->
      <b-row v-if="complianceWidgets" class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-collection-metrics'">
        <b-colxx class="pl-0 pb-6" xl="12" lg="12" md="12" :class="zoomGraphValue === 'overall-data-collection-metrics' ? 'overall-data-collection-metrics-zoom' : ''" style="transition-duration: 0.2s">
          <OverallCollectionMetrics
            :siteListInParticipants="siteListInParticipants"
            :collectionMetricsRaw="overallCollectionMetricRaw"
            :participantRaw="overallCollectionMetricParticipantRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :customType="'scrollstackedcolumn2d'"
            :zoomGraphValue="zoomGraphValue"
            :listParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.overallCollectionMetricRaw"
            v-on:zoomEnabled="zoomGraphValue = 'overall-data-collection-metrics'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Overall Data Collection with Completion Metrics"
          >
          </OverallCollectionMetrics>
        </b-colxx>
      </b-row>
      <!-- End Overall Data Collection with Completion Metrics   -->

      <!-- Daily Sensor Compliance   -->
      <b-row class="pb-10" v-show="(this.showDailySensor && zoomGraphValue === '') || zoomGraphValue === 'study-completion-data-table' || zoomGraphValue === 'study-completion-data-table'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'study-completion-data-table'" :class="zoomGraphValue === 'study-completion-data-table' ? 'col-xl-12 study-completion-data-table-zoom' : 'col-xl-12'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <DailySensorComplianceCard
            titleChart="Daily Sensor Compliance"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'study-completion-data-table'"
            @zoomDisabled="zoomGraphValue = ''"
            @updateTmpCountries="updateTmpCountries"
            @updateTmpSites="updateTmpSites"
            @newRawDataForSensor="newRawDataForSensor"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :siteListInParticipants="siteListInParticipants"
            :participantsSelected="participantsSelected"
            :fromDate="fromDate"
            :toDate="toDate"
            :rawdatacondition="(countrySelected == 'all' || !(countrySelected.length == 0)) && !(sitesSelected.length == 0) ? true : false"
            :selectedCountryIds="selectedCountryIds"
            :selectedSiteIds="selectedSiteIds"
          />
        </b-colxx>
      </b-row>
      <!-- End Daily Sensor Compliance   -->
      <!-- Cancelled Telehealth Visits  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'cancelled-telehealth-visits'">
        <b-colxx class="pl-0 pb-6" xl="12" lg="12" md="12" :class="zoomGraphValue === 'cancelled-telehealth-visits' ? 'cancelled-telehealth-visits-zoom' : ''" style="transition-duration: 0.2s">
          <CancelledTelehealthVisits
            :cancelledTelehealthVisitsRaw="cancelledTelehealthVisitsRaw"
            :specificSiteId="specificSiteId"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :cancelledTelehealthVisitsTabList="cancelledTelehealthVisitsTabList"
            v-on:zoomEnabled="zoomGraphValue = 'cancelled-telehealth-visits'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :zoomGraphValue="zoomGraphValue"
            titleChart="Cancelled Telehealth Visits"
            downloadId="cancelled-telehealth-visits"
            :dataLoaded="dataLoaded.cancelledTelehealthVisitsRaw"
            :filterTriggered="filterTriggered"
          >
          </CancelledTelehealthVisits>
        </b-colxx>
      </b-row>
      <!-- End Cancelled Telehealth Visits -->

      <b-row class="pb-10" v-show="zoomGraphValue == '' || zoomGraphValue == 'duration-of-telehealth-visits'">
        <b-colxx xl="12" lg="12" md="12" class="pl-0" style="transition-duration: 0.2s" :class="zoomGraphValue === 'duration-of-telehealth-visits' ? 'enrollment-sum-zoom' : ''">
          <fusion-line-chart
            containerId="blank"
            :rawData="durationOfTelehealthVisitsRaw"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Duration of Telehealth Visits"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :monthSelected="monthSelected"
            v-on:zoomEnabled="zoomGraphValue = 'duration-of-telehealth-visits'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :dataLoaded="dataLoaded['durationOfTelehealthVisitsRaw'] || false"
            :showTotalParticipant="false"
            :xyAxisValue="{ x: 'Time Frame', y: 'Minutes' }"
          ></fusion-line-chart>
        </b-colxx>
      </b-row>

      <!-- BEGIN COMPLETION AND COMPLIANCE CHART  -->
      <b-row v-if="complianceWidgets" class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'completion-data' || zoomGraphValue === 'compliance-data'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'completion-data'" :class="zoomGraphValue === 'completion-data' ? 'col-xl-12 completion-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <ActivitiesCompletionCard
            titleChart="Study Activity Completion by Day"
            :data="completionData"
            :participantData="completionDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'completion-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.completionData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'compliance-data'" :class="zoomGraphValue === 'compliance-data' ? 'col-xl-12 compliance-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <ActivitiesComplianceCard
            titleChart="Study Activity Compliance by Day"
            :data="complianceData"
            :participantData="complianceDataByParticipant"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'compliance-data'"
            @zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :studyId="studyId"
            :fromDate="fromDate"
            :toDate="toDate"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.complianceData"
            :participantsSelected="participantsSelected"
          />
        </b-colxx>
      </b-row>
      <!-- END COMPLETION AND COMPLIANCE  CHART  -->

      <!-- OVERALL MISSING DATA & DATA QUERIES  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-queries' || zoomGraphValue === 'overall-missing-data'">
        <b-colxx v-if="complianceWidgets" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-missing-data'" :class="zoomGraphValue === 'overall-missing-data' ? 'col-xl-12 overall-missing-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s">
          <OverallMissingDataCard
            titleChart="Overall Missing Data"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'overall-missing-data'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :rawSeries="overallMissingRaw"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.overallMissingRaw"
          />
        </b-colxx>
      </b-row>
      <!-- OVERALL MISSING DATA & DATA QUERIES  -->
    </div>
    </div>
  </div>
</template>

<script>
import _isEmpty from "lodash/isEmpty";
import _has from "lodash/has";
import Vue from "vue";
import _get from "lodash/get";
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import * as d3 from "d3";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import Loading from "vue-loading-overlay";
import complianceStatusMaps from "../containers/compliance-status-maps";
import ComplianceInsightsCard from "../containers/compliance-insights-card.vue";
import OverallCollectionMetrics from "../containers/overall-collection-metrics";
import DailySensorComplianceCard from "../containers/daily-sensor-compliance-card";
import OverallMissingDataCard from "../containers/overall-missing-data-card";
import ActivitiesCompletionCard from "../containers/activities-completion-card";
import ActivitiesComplianceCard from "../containers/activities-compliance-card";
import CancelledTelehealthVisits from "../containers/cancelled-telehealth-visits";
import ComplianceRateOverTime from "../containers/compliance-rate-over-time";
import * as utils from "../../services/visualization/utils";
import fusionLineChart from "../containers/fusion-line-chart";
import { getComplianceScore } from "../../services/visualization/study-compliance";
import * as commonHelper from "@/components/services/common-helper";

import "vue-loading-overlay/dist/vue-loading.css";
const visible = "10";

Vue.use(Loading);

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

export default {
  components: {
    HeaderDropDownFilter,
    ComplianceInsightsCard,
    OverallCollectionMetrics,
    OverallMissingDataCard,
    DailySensorComplianceCard,
    ActivitiesComplianceCard,
    ActivitiesCompletionCard,
    complianceStatusMaps,
    CancelledTelehealthVisits,
    ComplianceRateOverTime,
    "fusion-line-chart": fusionLineChart
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      showDailySensor: false,
      rawData: null,
      douprawParticipantStatus: null,
      checkingstatusofdata: null,
      filterTriggered: false,
      siteListInParticipants: [],
      studyId: null,
      countryList: [],
      tempCountryList: [],
      allSitesList: [],
      tempAllSitesList: [],
      callApiCompleted: null,
      participantList: [],
      sitesSelected: ["all"],
      participantsSelected: ["all"],
      countrySelected: "all",
      studySelected: null,
      studyList: null,
      leftHeaderTextValue: "Compliance Dashboard",
      monthSelected: [],
      fromDate: null, //fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      toDate: null,
      tabIndexOverallCollectionMetric: 0,
      overallCollectionMetricRaw: {},
      complianceInsightScoreRaw: {},
      complianceInsightScore: {},
      complianceInsightNonCompliantActivitiesRaw: {},
      complianceInsightNonCompliantActivities: {},
      overallCollectionMetricParticipantRaw: {},
      complianceData: [],
      completionData: [],
      complianceDataByParticipant: [],
      completionDataByParticipant: [],
      dataPicker: [],
      todaysDate: "",
      tabOverallMissing: 0,
      overallMissingRaw: null,
      overallMissingData: [],
      zoomGraphValue: "",
      specificSiteId: null, // you will get specific ID if you're not SystemAdmin
      tabListTotalAndPercentage: ["Total", "Percentage"],
      loader: null,
      isLoading: true,
      dataLoaded: {},
      tmpCountries: [],
      rawParticipantStatus: null,
      tmpSites: [],
      cancelledTelehealthVisitsRaw: {},
      durationOfTelehealthVisitsRaw: {},
      cancelledTelehealthVisitsTabList: ["Total", "Countries"],
      complianceRateOverTimeRawData: null,
      siteIdNameMaps: [],
      countryIdNameMaps: [],
      selectedSiteIds: [],
      selectedCountryIds: [],
      conversioninvalid: []
    };
  },
  methods: {
    updateTmpCountries(event) {
      this.tmpCountries = [...this.tmpCountries, ...event];
    },
    updateTmpSites(event) {
      this.tmpSites = [...this.tmpSites, ...event];
    },
    newRawDataForSensor(event) {
      this.showDailySensor = event;
    },
    getNewQueries() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate && this.toDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = this.$api.getQueriesEndpoint(params);

      if (data.ok) {
        const result = data.body;

        if (result.data !== {}) {
          if ("activities" in result.data) {
            response = result.data.activities;
          }
        }
      }

      this.isLoading = false;
      return response;
    },
    getComplianceData(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        let dbData = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }
        if (this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.studyComplianceData && (typeof(this.studyComplianceData) == "string" || this.studyComplianceData.meta) && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          this.setComplianceGraphData(this.studyComplianceData)
        } else {
          this.$api.getCompliance(params).then((data)=>{
            if (data.ok) {
              try {
                dbData = data.body;
                if(filterBy == "mounted"){
                  this.$store.dispatch("saveStudyComplianceData", dbData);
                  this.$store.dispatch("saveStudyId", this.studyId);
                }
                this.setComplianceGraphData(dbData);
              } catch (error) {
                return null;
              }
            }
          }).catch(() => {
            this.dataLoaded.completionData = true;
            this.dataLoaded.complianceData = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getParticipantComplianceData(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        let dbData = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }
        if (this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        params.groupBy = "participant";
        if (this.studyParticipantComplianceData && (typeof(this.studyParticipantComplianceData) == "string" || this.studyComplianceData.meta) && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          dbData = this.studyParticipantComplianceData;
          this.setParticipantComplianceGraphData(dbData)
        } else {
          this.$api.getCompliance(params).then((data)=>{
            if (data.ok) {
              try {
                dbData = data.body;
                if(filterBy == "mounted"){
                  this.$store.dispatch("saveStudyParticipantComplianceData", dbData);
                  this.$store.dispatch("saveStudyId", this.studyId);
                }
                this.setParticipantComplianceGraphData(dbData)
              } catch (error) {
                return null;
              }
            }
          }).catch(() => {
            this.dataLoaded.studyParticipantComplianceData = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getNewOverallCollection(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        if (this.overallCollectionData && this.overallCollectionData.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          const result = this.overallCollectionData.body;
          if (result.data && "activities" in result.data) {
            response = result.data.activities;
          }
          this.setOverallCollectionData(response)
        } else {
          this.$api.getOverallColectionEndpoint(params).then(data  => {
            if (data.ok) {
              this.dataLoaded.overallCollectionMetricRaw = true;
              const result = data.body;
              if(filterBy == "mounted"){
                this.$store.dispatch("saveOverallCollectionData", data);
                this.$store.dispatch("saveStudyId", this.studyId);
              }
              if (result.data !== null) {
                if ("activities" in result.data) {
                  response = result.data.activities;
                }
                this.setOverallCollectionData(response)
              }
            }
          }).catch(() => {
            this.dataLoaded.overallCollectionMetricRaw = true;
          });
        }

        this.isLoading = false;
        return response;
      }
    },
    getNewOverallCollectionParticipant(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.overallCollectionParticipantData && this.overallCollectionParticipantData.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          const result = this.overallCollectionParticipantData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
          }
          this.setOverallCollectionParticipantData(response)
        } else {
          this.$api.getOverallColectionParticipantEndpoint(params).then(data  => {
            if (data.ok) {
              const result = data.body;
              if(filterBy == "mounted"){
                this.$store.dispatch("saveOverallCollectionParticipantData", data);
                this.$store.dispatch("saveStudyId", this.studyId);
              }
              if (result.data !== {}) {
                if ("locations" in result.data) {
                  response = result.data.locations;
                }
                this.setOverallCollectionParticipantData(response)
              }
            }
          }).catch(() => {
            this.dataLoaded.overallCollectionMetricParticipantRaw = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getOverallMissingData(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        if (this.overallCollectionMissingData && this.overallCollectionMissingData.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          const result = this.overallCollectionMissingData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
          }
          this.setOverAllMissingData(response)
        } else {
          this.$api.getOverallColectionMissingEndpoint(params).then(data => {
            this.dataLoaded.overallMissingRaw = true;
            const result = data.body;
            if(filterBy == "mounted"){
              this.$store.dispatch('saveOverallCollectionMissingData', data);
              this.$store.dispatch('saveStudyId', this.studyId);
            }
            if (result.data) {
              if ("locations" in result.data) {
                response = result.data.locations;
              }
              this.setOverAllMissingData(response)
            }
          }).catch(() => {
            this.dataLoaded.overallMissingRaw = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getComplianceInsightScore(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }

        if (this.complianceInsightScoreData && this.complianceInsightScoreData.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          let result = this.complianceInsightScoreData.body;
          response = result.data ? result.data : {};
          this.setComplianceInsightScore(response);
        } else {
          this.$api.getComplianceInsightScore(params).then(data => {
            if (data) {
              let result = data.body;
              if(filterBy == "mounted"){
                this.$store.dispatch('saveComplianceInsightScore', data);
                this.$store.dispatch('saveStudyId', this.studyId);
              }
              response = result.data ? result.data : {};
              this.setComplianceInsightScore(response);
            }
          }).catch(() => {
            this.dataLoaded.complianceInsightScoreRaw = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getComplianceInsightNonCompliantActivities(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate && this.toDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.nonCompliantActivities && this.nonCompliantActivities.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          let result = this.nonCompliantActivities.body;
          response = result.data ? result.data : {};
          this.setComplianceInsightNonCompliantActivities(response);
        } else{
          this.$api.getComplianceInsightNonCompliantActivities(params).then(data => {
            if (data) {
              let result = data.body;
              if(filterBy == "mounted"){
                this.$store.dispatch('saveNonCompliantActivities', data);
                this.$store.dispatch('saveStudyId', this.studyId);
              }
              response = result.data ? result.data : {};
              this.setComplianceInsightNonCompliantActivities(response);
            }
          }).catch(() => {
            this.dataLoaded.complianceInsightNonCompliantActivities = true;
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getCancelledTelehealthVisits(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate && this.toDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }

      if (this.cacelledTelehealthVisits && this.cacelledTelehealthVisits.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
        let result = this.cacelledTelehealthVisits.body;
        if (result.data !== {}) {
          response = { countries: result.data.countries };
          this.setCancelledTelehealthVisitData(response);
        }
      } else {
        this.$api.getDataTelehealthVisitsCancelled(params, body).then(data => {
          if (data) {
            let result = data.body;
            if(filterBy == "mounted"){
              this.$store.dispatch('saveCancelledThVisitData', data);
              this.$store.dispatch('saveStudyId', this.studyId);
            }
            if (result.data !== {}) {
            response = { countries: result.data.countries };
            this.setCancelledTelehealthVisitData(response);
            }
          }
        }).catch(() => {
          this.dataLoaded.cancelledTelehealthVisitsRaw = true;
        });
      }
      this.isLoading = false;
      return response;
    },
    getDurationOfTelehealthVisits(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate && this.toDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if(this.telehealthVisitsDuration && this.telehealthVisitsDuration.body && this.checkCurrentSiteOrStudy && filterBy !== "date"){
        const result = this.telehealthVisitsDuration.body;
        response = result.data;
        this.setDurationOfTelehealthVisitsData(response);
      } else {
        this.$api.getDataTelehealthVisitsDuration(params, body).then(data=> {
          if (data) {
            const result = data.body;
            if(filterBy == "mounted"){
              this.$store.dispatch('saveTelehealthVisitsDuration', data);
              this.$store.dispatch('saveStudyId', this.studyId);
            }
            if (result.data !== {}) {
              response = result.data;
            }
            this.setDurationOfTelehealthVisitsData(response);
          }
        }).catch(() => {
          this.dataLoaded.durationOfTelehealthVisitsRaw = true;
        });
      }
      this.isLoading = false;
      return response;
    },
    getComplianceRateOverTime(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate && this.toDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.complianceRateOverTime && this.complianceRateOverTime.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
        const result = this.complianceRateOverTime.body;
        response = result.data;
        this.setComplianceRateOverTime(response)
      } else {
        this.$api.getComplianceRateOverTime(params, body).then((data) => {
          if (data.ok) {
            const result = data.body;
            if(filterBy == "mounted"){
              this.$store.dispatch("saveComplianceRateOverTime", data);
              this.$store.dispatch("saveStudyId", this.studyId);
            }
            if (result.data !== {}) {
              response = result.data;
              this.setComplianceRateOverTime(response)
            }
          }
        }).catch(() => {
          this.dataLoaded.complianceRateOverTimeRawData = true;
        });
      }

      this.isLoading = false;
      return response;
    },
    getSitesID() {
      if(this.sitesData && this.sitesData.length > 0 && this.checkCurrentSiteOrStudy){
        if (!_isEmpty(this.sitesData)) {
          const res = utils.getSiteNameAndCountryNameMaps(this.sitesData);
          this.siteIdNameMaps = res.siteIdNameMaps;
          this.countryIdNameMaps = res.countryIdNameMaps;
        }
        return this.sitesData;
      } else {
        this.isLoading = true;
        let response = null;
        try{
          this.$api.getSitesFact(this.studyId).then((res)=>{
          if(res){
            const result = res.body;
            this.$store.dispatch("saveSitesData", result);
            this.$store.dispatch("saveStudyId", this.studyId);
            commonHelper.setSiteId();
            if (!_isEmpty(result)) {
              response = result;
              const res = utils.getSiteNameAndCountryNameMaps(response);
              this.siteIdNameMaps = res.siteIdNameMaps;
              this.countryIdNameMaps = res.countryIdNameMaps;
            }
          }
        });
        } catch (err) {
          console.error(err);
        }
        this.isLoading = false;
        return response;
      }
    },

    generateAxisTimeActivities(tab = 0) {
      let axisName = "";
      switch (tab) {
        case 0:
          axisName = "Activities";
          break;
        case 1:
          axisName = "Countries";
          break;
        case 2:
          axisName = "Sites";
          break;
        default:
          axisName = "Activities";
          break;
      }

      return axisName;
    },
    getDataFromRadioButton(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getDataFromCheckbox(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getParticipantsDataFromCheckbox(payload) {
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },
    getRangeMonth(payload) {
      this.filter("date", payload, payload.detailSite);
    },
    getSiteData(rawData, searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      const siteData = _.find(rawData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },
    filter(triggerBy, filterValue, detailSite) {
      switch (triggerBy) {
        case "country": {
          this.countrySelected = filterValue;
          const payload = {
            countries: {
              ...this.overallCollectionMetricParticipantRaw,
              ...this.overallMissingRaw
            },
            countriesByActivities: {
              ...this.queriesRaw,
              ...this.overallCollectionMetricRaw
            },
            countriesByD3Nest: [...this.complianceData, ...this.complianceDataByParticipant]
          };
          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          let filteredSites = utils.getAllSitesWhenFilteringCountry(payload, countrySelected);
          this.sitesSelected = filterValue === "all" ? ["all"] : filteredSites;
          this.selectedCountryIds = utils.getSiteIdsBySiteNames(this.countryIdNameMaps, countrySelected);
          this.selectedSiteIds = utils.getSiteIdsBySiteNames(this.siteIdNameMaps, this.sitesSelected);
          break;
        }
        case "site":
          // todo logic here
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          this.countrySelected = utils.getCountryWhenSiteFilterApply(filterValue, this.countrySelected, detailSite, this.countryList);
          this.selectedCountryIds = utils.getSiteIdsBySiteNames(this.countryIdNameMaps, this.countrySelected);
          this.selectedSiteIds = utils.getSiteIdsBySiteNames(this.siteIdNameMaps, this.sitesSelected);
          break;
        case "date": {
          this.monthSelected = filterValue;
          //TODO THIS IS ONLY for TESTING. DELETE AFTER DATE FILTER CALENDAR IMPLEMENTED
          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;
          //END TODO TESTING CODE

          this.callApi(true, triggerBy);

          this.loader ? this.loader.hide() : "";
          this.isLoading = false;
          break;
        }
        case "participant":
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
          } else {
            this.callApi(true, triggerBy);
            this.isLoading = false;
          }
          break;
        default:
          break;
      }
      this.filterTriggered = !this.filterTriggered;
    },
    getBrandingDetails() {
      try {
        const data = this.$api.getBrandingDetailsFact(this.studyId);
        if (data.ok) {
          return data.body;
        } else {
          return null;
        }
      } catch (err) {
        return null;
      }
    },
    setToEmptyData() {
      this.rawParticipantStatus = null;
      this.queriesRaw = null;
      this.overallCollectionMetricRaw = null;
      this.overallCollectionMetricParticipantRaw = null;
      this.overallMissingRaw = null;
      this.complianceDataByParticipant = null;
      this.completionDataByParticipant = null;
      this.complianceData = null;
      this.completionData = null;
      this.cancelledTelehealthVisitsRaw = null;
      this.durationOfTelehealthVisitsRaw = {};
      this.complianceRateOverTimeRawData = null;
    },
    getParticipantStatusmappoints(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = {
          locations: null,
          boundaries: null
        };
        const params = {
          studyId: this.studyId
        };
        const body = {};
        if (this.fromDate) {
          body.fromDate = this.fromDate;
          body.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          body.participantsIds = this.participantsSelected;
        }
        if (this.specificSiteId.length > 0) {
          body.siteId = this.specificSiteId[0];
        }
        if (this.graphicComplianceData && this.graphicComplianceData.body && this.checkCurrentSiteOrStudy && filterBy !== "date") {
          let result = this.graphicComplianceData.body;
          this.checkingstatusofdata = this.graphicComplianceData;
          this.dataLoaded.rawParticipantStatus = true;
          if(_has(result, "data")) {
            response = _get(result, "data", null);
            this.getConversionId(response);
          }
        } else {
          this.$api.getgraphiccompliance(params, body).then(data => {
            if (data.ok) {
              this.dataLoaded.rawParticipantStatus = true;
              const result = data.body;
              this.checkingstatusofdata = data;
              if(filterBy == "mounted"){
                this.$store.dispatch("saveGraphicComplianceData", data);
                this.$store.dispatch("saveStudyId", this.studyId);
              }
              if (!_isEmpty(result.data)) {
                if (_has(result, "data")) {
                  response = _get(result, "data", null);
                  this.getConversionId(response);
                }
              }
            }
          }).catch(() => {
            this.dataLoaded.rawParticipantStatus = true;
          });
        }
        this.isLoading = false;
        this.douprawParticipantStatus = response;
        return response;
      }
    },
    prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      const tmpPicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        tmpPicker.push(m.format("YYYY-MM-DD"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },

    callApi(turnOffGlobalLoader = false, filterBy) {
      this.resetDataLoaded();
      this.$router.push({ query: { automatic_off_loader: false } });
      if (["mounted", "date", "participant"].includes(filterBy)) {
        this.getNewOverallCollection(filterBy);
        this.getParticipantStatusmappoints(filterBy);
        this.getNewOverallCollectionParticipant(filterBy);
        this.getOverallMissingData(filterBy);
        this.getComplianceInsightScore(filterBy);
        this.getComplianceInsightNonCompliantActivities(filterBy);
        this.getCancelledTelehealthVisits(filterBy);
        this.getDurationOfTelehealthVisits(filterBy);
        this.getComplianceRateOverTime(filterBy);
        this.getComplianceData(filterBy);
        this.getParticipantComplianceData(filterBy);
      }
      if (["mounted"].includes(filterBy)) {
        this.getSitesID(filterBy);
      }
    },

    turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    },
    setComplianceGraphData(dbData) {
      this.dataLoaded.completionData = true;
      this.dataLoaded.complianceData = true;
      let response = null;
      if(typeof(dbData) === "string"){
        if (dbData) {
          response = d3.csvParse(dbData);
          response = d3
            .nest()
            .key(d => d.date)
            .sortKeys(d3.ascending)
            .key(d => d.countryName)
            .sortKeys(d3.ascending)
            .key(d => d.siteName)
            .sortKeys(d3.ascending)
            .entries(response);
        }
        this.setComplianceData(response);
      }
    },
    setComplianceData(response) {
      const countries = utils.getCountriesFromD3NestResult(response);
      const sites = utils.getSitesFromD3NestResult(response, countries);
      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.complianceData = response;
      this.completionData = response;
    },
    setParticipantComplianceGraphData(dbData) {
      this.dataLoaded.studyParticipantComplianceData = true;
      let response = null;
      if(typeof(dbData) === "string"){
        if (dbData) {
          response = d3.csvParse(dbData);
          response = d3
            .nest()
            .key(d => d.date)
            .sortKeys(d3.ascending)
            .key(d => d.countryName)
            .sortKeys(d3.ascending)
            .key(d => d.siteName)
            .sortKeys(d3.ascending)
            .entries(response);
          this.setParticipantComplianceData(response);
        }
      }
    },
    setParticipantComplianceData(response) {
      const countries = utils.getCountriesFromD3NestResult(response);
      const sites = utils.getSitesFromD3NestResult(response, countries);

      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.complianceDataByParticipant = response;
      this.completionDataByParticipant = response;
    },
    setOverallCollectionData(response){
      const countries = utils.getCountriesByActivities(response);
      const sites = utils.getSiteByActivities(response, countries);

      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.overallCollectionMetricRaw = response;
      this.dataLoaded.overallCollectionMetricRaw = true;
    },
    setOverallCollectionParticipantData(response){
      const countries = utils.getCountries(response);
      const sites = utils.getSites(response, countries);

      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.overallCollectionMetricParticipantRaw = response;
      this.dataLoaded.overallCollectionMetricParticipantRaw = true;
    },
    setOverAllMissingData(response){
      const countries = utils.getCountries(response);
      const sites = utils.getSites(response, countries);

      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.overallMissingRaw = response;
      this.dataLoaded.overallMissingRaw = true;
    },
    setCancelledTelehealthVisitData(response){
      const countries = utils.getCountriesByActivities(response);
      const sites = utils.getSiteByActivities(response, countries);
      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.cancelledTelehealthVisitsRaw = response;
      this.dataLoaded.cancelledTelehealthVisitsRaw = true;
    },
    setDurationOfTelehealthVisitsData(response){
      const countries = utils.getCountries(response.locations);
      const sites = utils.getSites(response.locations, countries);
      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.durationOfTelehealthVisitsRaw = response;
      this.dataLoaded.durationOfTelehealthVisitsRaw = true;
    },
    setComplianceRateOverTime(response){
      const countries = utils.getCountries(response);
      const sites = utils.getSites(response, countries);
      this.tmpCountries = this.tmpCountries.concat(countries);
      this.tmpSites = this.tmpSites.concat(sites);
      this.complianceRateOverTimeRawData = response;
      this.dataLoaded.complianceRateOverTimeRawData = true;
    },
    getConversionId(rawData) {
      if (!(this.conversioninvalid == 0)) {
        this.conversioninvalid.splice(0, this.conversioninvalid.length);
      }
      if (this.Countrysite) {
        for (let j in rawData) {
          for (const p in rawData[j]) {
            const siteanme = p;
            const alldata = rawData[j][p];
            const temp = {
              siteanme: siteanme,
              ...alldata
            };
            this.conversioninvalid.push(temp);
          }
        }
      } else {
        const countrySelected = this.countrySelected == "all" ? this.countryList : this.countrySelected;
        const siteSelected = this.sitesSelected == "all" ? this.allSitesList : this.sitesSelected;
        const countryfilter = countrySelected;
        const stateselected = siteSelected;
        for (const k in countryfilter) {
          for (const i in rawData) {
            if (countryfilter[k] == i) {
              for (const l in stateselected) {
                for (let j in rawData[i]) {
                  if (stateselected[l] == j) {
                    const siteanme = j;
                    const alldata = rawData[i][j];
                    const temp = {
                      siteanme: siteanme,
                      ...alldata
                    };
                    this.conversioninvalid.push(temp);
                  }
                }
              }
            }
          }
        }
      }
      return this.conversioninvalid;
    },
    setComplianceInsightNonCompliantActivities(response){
      this.complianceInsightNonCompliantActivitiesRaw = response;
      this.complianceInsightNonCompliantActivities = response;
      this.dataLoaded.complianceInsightNonCompliantActivities = true;
    },
    setComplianceInsightScore(response){
      this.complianceInsightScore = getComplianceScore(response);
      this.complianceInsightScoreRaw = response;
      this.dataLoaded.complianceInsightScoreRaw = true;
    },
    resetDataLoaded(){
      this.$set(this.dataLoaded, "completionData", false);
      this.$set(this.dataLoaded, "complianceData", false);
      this.$set(this.dataLoaded, "overallCollectionMetricRaw", false);
      this.$set(this.dataLoaded, "overallMissingRaw", false);
      this.$set(this.dataLoaded, "cancelledTelehealthVisitsRaw", false);
      this.$set(this.dataLoaded, "durationOfTelehealthVisitsRaw", false);
      this.$set(this.dataLoaded, "complianceRateOverTimeRawData", false);
      this.$set(this.dataLoaded, "rawParticipantStatus", false);
      this.$set(this.dataLoaded, "overallCollectionMetricParticipantRaw", false);
      this.$set(this.dataLoaded, "complianceInsightScoreRaw", false);
      this.$set(this.dataLoaded, "complianceInsightNonCompliantActivities", false);
      this.$set(this.dataLoaded, "studyParticipantComplianceData", false);
    }
  },
  watch: {
    douprawParticipantStatus: function(val) {
      if (val) {
        this.douprawParticipantStatus = val;
      }
    },
    tmpCountries: function(val) {
      // Do logic here
      if(this.sitesSelected[0] == "all" || this.sitesSelected == "all"){
        const allCountries = _.uniq(val);
        this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
      }
    },

    tmpSites: function(val) {
      // Do logic here
      if(this.sitesSelected[0] == "all" || this.sitesSelected == "all"){
        const allSites = _.uniq(val);
        this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
        if(this.graphicComplianceData && this.graphicComplianceData.body && this.allSitesList.length > 0){
          this.getConversionId(this.graphicComplianceData.body.data);
        }
      }
    },

    queriesRaw: function(newValue) {
      this.queriesRaw = newValue;
    },

    overallMissingRaw: function(newValue) {
      this.overallMissingRaw = newValue;
    },

    complianceInsightScore: function(newValue) {
      this.complianceInsightScore = newValue;
    },
    isDataLoaded:{
      handler(value){
        if(value === true){
          this.callApiCompleted = true;
          this.turnOffGlobalLoader();
        }
      }
    }
  },

  computed: {
    ...mapGetters(["user", "sitesData", "studyIdValue", "overallCollectionData", "cacelledTelehealthVisits", "complianceInsightScoreData", "overallCollectionMissingData", "nonCompliantActivities", "telehealthVisitsDuration", "complianceRateOverTime", "studyComplianceData", "studyParticipantComplianceData", "overallCollectionParticipantData", "graphicComplianceData", "selectedSiteId"]),
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.selectedSiteId));
    },
    getDouprawParticipantStatus(){
      let responseBody = (this.graphicComplianceData && this.graphicComplianceData.body) ? this.graphicComplianceData.body : {};
      if(responseBody){
        return responseBody.data;
      }
      else{
        return {};
      }
    },
    isDataLoaded(){
      return this.dataLoaded.completionData &&
        this.dataLoaded.complianceData &&
        this.dataLoaded.overallCollectionMetricRaw &&
        this.dataLoaded.overallMissingRaw &&
        this.dataLoaded.cancelledTelehealthVisitsRaw &&
        this.dataLoaded.durationOfTelehealthVisitsRaw &&
        this.dataLoaded.complianceRateOverTimeRawData &&
        this.dataLoaded.rawParticipantStatus &&
        this.dataLoaded.overallCollectionMetricParticipantRaw &&
        this.dataLoaded.complianceInsightScoreRaw &&
        this.dataLoaded.complianceInsightNonCompliantActivities &&
        this.dataLoaded.studyParticipantComplianceData;
    }
  },

  mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);
    const tabList = [
      { name: "Activities", visible: "12" },
      { name: "Countries", visible }
    ];
    if (this.specificSiteId.length === 0) {
      tabList.push({ name: "Sites", visible });
      this.cancelledTelehealthVisitsTabList.push("Sites");
    }
    tabList.push({ name: "Participants", visible });
    this.tabList = tabList;
    this.callApi(true, "mounted");
  }
};
</script>

<style scoped>
.full-width {
  margin-left: -15px !important;
  margin-right: -15px !important;
}
.greyout-dashboard {
  opacity: 0.4;
}
</style>
